define("ember-composable-helpers/helpers/values", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.values = values;
  function values(_ref) {
    let [object] = _ref;
    if (!object) {
      return object;
    }
    return Object.values(object);
  }
  var _default = _exports.default = (0, _helper.helper)(values);
});